var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58759 6.5635C5.45425 6.5635 5.32925 6.5425 5.21259 6.5005C5.09592 6.45917 4.98759 6.3885 4.88759 6.2885L0.262587 1.6635C0.0792536 1.48017 -0.00807986 1.25084 0.000586805 0.975502C0.00858681 0.700835 0.104253 0.471835 0.287587 0.288502C0.47092 0.105169 0.704253 0.0135013 0.987587 0.0135013C1.27092 0.0135013 1.50425 0.105169 1.68759 0.288502L5.58759 4.1885L9.51259 0.263501C9.69592 0.0801679 9.92525 -0.00749826 10.2006 0.000501745C10.4753 0.00916841 10.7043 0.105169 10.8876 0.288502C11.0709 0.471835 11.1626 0.705168 11.1626 0.988502C11.1626 1.27183 11.0709 1.50517 10.8876 1.6885L6.28759 6.2885C6.18759 6.3885 6.07925 6.45917 5.96259 6.5005C5.84592 6.5425 5.72092 6.5635 5.58759 6.5635V6.5635Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.d09c51a14b8c90a0aaf1107f68edb5eb.svg";
export { ForwardRef as ReactComponent };